import { render, staticRenderFns } from "./QRView.vue?vue&type=template&id=6b829b58&scoped=true&lang=pug&"
import script from "./QRView.vue?vue&type=script&lang=js&"
export * from "./QRView.vue?vue&type=script&lang=js&"
import style0 from "./QRView.vue?vue&type=style&index=0&id=6b829b58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b829b58",
  null
  
)

export default component.exports